import {ApplicationConfig, importProvidersFrom} from "@angular/core";
import {AppRoutingModule, routes} from "./app-routing.module";
import {GoogleLoginProvider, SocialAuthServiceConfig, SocialLoginModule} from "@abacritt/angularx-social-login";
import {RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module} from "ng-recaptcha";
import {
    HTTP_INTERCEPTORS,
    provideHttpClient,
    withFetch,
    withInterceptorsFromDi
} from "@angular/common/http";
import {JwtInterceptor} from "./helpers/jwt.interceptor";
import {ErrorInterceptor} from "./helpers/error.interceptor";
import {environment} from "../environments/environment";
import {LocalSettingsService} from "./services/local-settings.service";
import {CountryService} from "./services/country.service";
import {RedirectionTrackingService} from "./services/user-services/redirection-tracking.service";
import {provideAnimations, provideNoopAnimations} from "@angular/platform-browser/animations";
import {PreloadAllModules, provideRouter, withPreloading} from "@angular/router";
import {PlatformService} from "./services/platform-service.service";
import {TranslateService} from "@ngx-translate/core";
import {MatStepperModule} from "@angular/material/stepper";
import {MatNativeDateModule} from "@angular/material/core";
import {BsDropdownModule} from "ngx-bootstrap/dropdown";
import {MatSnackBarModule} from "@angular/material/snack-bar";
import {NgScrollbarModule} from "ngx-scrollbar";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatSortModule} from "@angular/material/sort";
import {MatButtonModule} from "@angular/material/button";
import {HousingCertificateRoutingModule} from "./pages/processes/housing-certificate/housing-certificate.module";
import {AppBackcareModule} from "./admin/app-backcare.module";
import {AccommodationModule} from "./pages/processes/accommodation/accommodation.module";
import {NgCircleProgressModule} from "ng-circle-progress";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {NgxIntlTelInputModule} from "@justin-s/ngx-intl-tel-input";
import {MatFormFieldModule} from "@angular/material/form-field";
import {ReactiveFormsModule} from "@angular/forms";
import {CustomPreloadingService} from "./services/custom-preloading-service.service";
import {provideClientHydration, withHttpTransferCacheOptions} from "@angular/platform-browser";

export const appConfig: ApplicationConfig = {
    providers: [
      importProvidersFrom(AppRoutingModule, MatStepperModule, MatNativeDateModule, BsDropdownModule.forRoot(), MatSnackBarModule, NgScrollbarModule, MatCheckboxModule, MatDatepickerModule, MatSortModule, MatButtonModule, HousingCertificateRoutingModule, AppBackcareModule, AccommodationModule, SocialLoginModule, NgCircleProgressModule.forRoot({
        radius: 100,
        outerStrokeWidth: 16,
        innerStrokeWidth: 0,
        outerStrokeColor: '#151F63',
        innerStrokeColor: '#749FF3',
        animationDuration: 300,
      }), NgbModule, FontAwesomeModule, NgxIntlTelInputModule, MatFormFieldModule, ReactiveFormsModule, RecaptchaV3Module),
      { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        {
            provide: RECAPTCHA_V3_SITE_KEY,
            useValue: environment.recaptcha.siteKey,
        },
        LocalSettingsService,
        PlatformService,
        TranslateService,
        CountryService,
        RedirectionTrackingService,
        {
            provide: 'SocialAuthServiceConfig',
            useValue: {
                autoLogin: false,
                providers: [
                    {
                        id: GoogleLoginProvider.PROVIDER_ID,
                        provider: new GoogleLoginProvider('859837974225-mdtftc4h7hofg8v178tbglmh326pkilr.apps.googleusercontent.com'),
                    },
                ],
            } as SocialAuthServiceConfig,
        },
        provideAnimations(),
      provideNoopAnimations(),
        provideRouter(routes,
            withPreloading(PreloadAllModules)),
      provideHttpClient(withInterceptorsFromDi(), withFetch()),
      provideClientHydration(withHttpTransferCacheOptions({
        includePostRequests: true
      }))
    ]
};
